import type { RouteRecordRaw } from 'vue-router';

// Access-control pages (members / service accounts / roles), migrated out of
// the legacy sub — `/management` is dropped from LEGACY_OWNED_PATHS, so these
// records fully own the prefix.
const managementRoutes: RouteRecordRaw[] = [
  {
    // Bare /management (the sidebar group header targets it, and it is
    // hand-typable) → members, which is also where the sidebar's group-expand
    // sends the user. Legacy rendered an empty layout here.
    path: '/management',
    redirect: '/management/member',
  },
  {
    path: '/management/member',
    name: 'management-members',
    component: () => import('@/domains/access/views/MembersView.vue'),
    meta: { renderer: 'native', perms: ['member@all'] },
  },
  {
    path: '/management/member/:id',
    name: 'management-member-detail',
    component: () => import('@/domains/access/views/MemberDetailView.vue'),
    meta: { renderer: 'native', perms: ['member@all'] },
  },
  {
    // Lowercase segment — the legacy URL shape, which existing links and
    // bookmarks use.
    path: '/management/serviceaccount/:id',
    name: 'management-service-account-detail',
    component: () => import('@/domains/access/views/ServiceAccountDetailView.vue'),
    meta: { renderer: 'native', perms: ['member@all'] },
  },
  {
    path: '/management/role',
    name: 'management-roles',
    component: () => import('@/domains/access/views/RolesView.vue'),
    meta: { renderer: 'native', perms: ['role@all'] },
  },
  {
    path: '/management/role/:id',
    name: 'management-role-detail',
    component: () => import('@/domains/access/views/RoleDetailView.vue'),
    meta: { renderer: 'native', perms: ['role@all'] },
  },
];

export default managementRoutes;
